import styled from "styled-components";

export const PremiumStoreInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const FranchisePubsItemWrapper = styled.div`
  width: 100%;
  aspect-ratio: 1/1;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  > img {
    width: 100%;
    height: calc(100% - 8px);
    object-fit: cover;
    border-radius: 8px 8px 0 0;
    flex-shrink: 0;
  }

  > .more {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 22px;
    height: 22px;
  }
`;

export const FranchisePubsItemStatusWrapper = styled.div<{
  isStart: boolean;
}>`
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(p) => (p.isStart ? "#6436E7" : "#B7B7B7")};
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-radius: 0 0 8px 8px;
`;

export const FranchisePubInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FranchisePubInfoRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 2px;

  > .pub-name {
    color: #121212;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.24px;
  }

  > .address {
    height: 24px;
    color: #444;
    font-family: Pretendard;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.2px;
  }
`;

export const FranchisePubLikeWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
`;

export const FranchisePubLikeItem = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  > .like-count,
  > .distance-count {
    color: #999;
    font-family: Pretendard;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.2px;
  }

  > img {
    width: 12px;
    height: 12px;
  }
`;

export const FranchiseReservationButton = styled.div<{ isActive: boolean }>`
  width: 51px;
  height: 20px;
  border-radius: 50px;
  background: ${(p) => (p.isActive ? "#6436E7" : "#B7B7B7")};
  color: #fff;
  font-family: Pretendard;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  position: absolute;
  right: 35px;
  top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FranchiseLiveWrapper = styled.div`
  width: 87px;
  height: 20px;
  border-radius: 50px;
  background: #000;
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  position: absolute;
  left: 8px;
  bottom: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px 0 0;
  overflow: hidden;

  > .title {
    width: 33px;
    height: 100%;
    border-radius: 50px;
    background: #f00;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > .rolling-wrapper {
    flex: 1;
    overflow: hidden;
    position: relative;
    height: 100%;

    > .rolling-track {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;

      > .rolling-text {
        display: flex;
        animation: rolling 10s infinite linear;
        white-space: nowrap;

        > div {
          margin-right: 8px;
        }

        @keyframes rolling {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      }
    }
  }
`;
